import React from 'react'
import PropTypes from 'prop-types'
import { Icon as OldIcon } from '../../../components/generic'
import { Icon } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'

export default function ResidentProfileSectionWrapper({
  antdIcon,
  color,
  icon,
  style,
  title,
  children,
}) {
  return (
    <div style={style}>
      <div style={styles.sectionHeaderContainer}>
        <div
          style={{
            ...styles.iconContainer,
            background: color,
          }}
        >
          {antdIcon ? (
            <Icon name={antdIcon} style={styles.antdIcon} />
          ) : (
            <OldIcon name={icon} />
          )}
        </div>
        <div style={styles.sectionHeader}>{title}</div>
      </div>
      {children}
    </div>
  )
}

const styles = {
  antdIcon: {
    color: colors.white,
    fontSize: 22,
  },
  iconContainer: {
    alignItems: 'center',
    background: colors.darkblue,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 1,
    height: 40,
    width: 40,
  },
  sectionHeader: {
    alignSelf: 'flex-end',
    borderColor: colors.grey,
    fontSize: 24,
    flex: 1,
    marginLeft: 12,
  },
  sectionHeaderContainer: {
    display: 'flex',
    marginBottom: 20,
  },
}

ResidentProfileSectionWrapper.propTypes = {
  antdIcon: PropTypes.any,
  children: PropTypes.any,
  color: PropTypes.string.isRequired,
  icon: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
}
